// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host .account {
  cursor: pointer;
}
:host .account cs-icon {
  color: var(--cs-primary-color);
  font-size: 1rem;
  font-weight: 400;
}
:host .account:hover {
  color: rgba(255, 255, 255, 0.75);
}
:host .account .cs-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #f2f5f8;
}
:host.cs-nav-drop-down-opened {
  background: #fff;
}
:host.cs-nav-drop-down-opened p.account {
  color: #000;
}
:host .cs-nav-drop-down-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}
:host .cs-nav-drop-down {
  position: fixed;
  right: 0;
  top: 62px;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 270px;
  box-shadow: -3px 4px 6px 0 rgba(196, 196, 196, 0.4);
}
:host .cs-nav-drop-down .profile-name {
  padding: 1.5rem;
  display: flex;
  align-items: center;
}
:host .cs-nav-drop-down .profile-name .property-profile-img {
  height: 45px;
  width: 45px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  border: 1px solid #b0c7d5;
  background-repeat: no-repeat;
}
:host .cs-nav-drop-down .profile-name .user-details {
  margin-left: 1rem;
  word-break: break-all;
}
:host .cs-nav-drop-down .profile-name .user-details .name {
  font-size: 14px;
  font-family: Roboto-Medium;
  color: #000;
}
:host .cs-nav-drop-down .profile-name .user-details .email {
  font-size: 13px;
  color: #8f8f8f;
}
:host .cs-nav-drop-down .profile-name .user-details .account-setting-link {
  color: #000;
  cursor: pointer;
  padding-bottom: 5px;
  outline: none;
}
:host .cs-nav-drop-down .profile-name .user-details .account-setting-link:hover {
  color: var(--cs-primary-color);
  text-decoration: none;
}
:host .cs-nav-drop-down .profile-name .user-details .account-setting-link:last-child {
  padding-bottom: 0;
}
:host .cs-nav-drop-down .account-settings {
  padding: 1.3rem 1.5rem 1rem;
  border-top: 1px solid #ddd;
}
:host .cs-nav-drop-down .account-settings .account-setting-link {
  display: block;
  color: #6586b3;
  font-size: 13px;
  padding-bottom: 5px;
  cursor: pointer;
}
:host .cs-nav-drop-down .account-settings .account-setting-link:hover {
  color: var(--cs-primary-color);
  text-decoration: none;
}
:host .cs-nav-drop-down h6 {
  color: #000;
  font-family: Roboto-Medium;
}
:host .cs-nav-drop-down p {
  margin-bottom: 0;
}
:host .properties-wrapper {
  margin-bottom: 60px;
  overflow: auto;
}
:host .properties-wrapper .projects-list {
  background: #a4b6c9;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-right: 1.5rem;
}
:host .properties-wrapper .projects-list h3 {
  color: #000;
  font-size: 14px;
  margin-bottom: 0;
  padding: 1rem 2rem;
}
:host .properties-wrapper .d-company-list {
  border-bottom: 1px solid #dfe3eb;
}
:host .properties-wrapper .d-company-list .d-company {
  padding: 0.8rem 1.5rem;
}
:host .properties-wrapper .d-company-list .d-company.cs-expanded {
  background: #d1dbe6;
}
:host .properties-wrapper .d-company-list .d-company img {
  width: 25px;
}
:host .properties-wrapper .d-company-list .d-company h6 {
  color: #212529;
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 1rem;
  font-size: 15px;
}
:host ul.d-properties {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}
:host ul.d-properties .all-project-bg {
  font-size: 15px;
  font-family: Roboto-Medium;
}
:host ul.d-properties li {
  background: #f5f8fa;
}
:host ul.d-properties li button {
  text-decoration: none;
  color: #5e686e;
  font-size: 14px;
  background-color: transparent;
  border: 0;
  outline: 0;
  width: 270px;
  text-align: left;
  padding: 0.6rem 2rem 0.6rem 3.5rem;
}
:host ul.d-properties li button:hover {
  color: var(--cs-primary-color);
  text-decoration: none;
  background-color: #fff;
}
:host ul.d-properties li .all-proj {
  padding-left: 2.5rem;
}
:host .log-out {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: var(--cs-secondary-color);
  text-align: center;
  display: flex;
  justify-content: center;
  border: 0;
}
:host .log-out span {
  background-color: transparent;
  border: 0;
  padding: 14px 10px;
  color: #fff;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
